module Meevo.Plugins.Register {
    export class ClientBirthdayController {
        static $inject = ['messages'];

        constructor(private messages) {
            
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.ClientBirthdayController", ClientBirthdayController);
}